function showUserSessionCountdown() {
    setTimeout(sessionNotifyOpen, 100);
    setTimeout(showUserSessionCountdownDateTime, 300);    
}

function showUserSessionCountdownDateTime() {
        
    $('#defaultCountdown').each(function (i, el) {

        var counterExpiryDateTime = moment.tz(el.dataset.timeCounter, el.dataset.timeZone);          
        $(el).countdown(counterExpiryDateTime.toDate()).on('update.countdown', function (event) {
            
            var format = el.dataset.timeFormat || '%H:%M:%S';
            $(this).html(event.strftime(format));
            
        }).on('finish.countdown', function (event) {            
            destroyCountdown();
            onExpiry();         
        });
    });
}

function onExpiry() {
    sessionNotifyClose();
    setTimeout(expiry, 500);
}

function expiry() {
    $('#btnInvalidateSession').click(); //Invalidate session
    var url = $('#ibe-base-url').val(); //Get URL 
    var msg = $('#message-session-expired').val(); //Get message
    window.alert(msg);
    window.location.href = url;
}

function destroyCountdown() {
    $('#defaultCountdown').countdown('remove');
}

function sessionNotifyOpen() {
    window.TL.ui.SessionNotify.open();
}

function sessionNotifyClose() {
    window.TL.ui.SessionNotify.close();
}